module.exports = __webpack_public_path__ + "media/investment_locations/Leipzig-b8003a27.png";